import * as React from 'react';
import { AddUniversal } from '@duxton-web/icons';
import { Button, Popover, Tooltip } from '@duxton-web/ui';

import { ControlledInputPropsBase } from '../../common/InputControlProps';
import AppVersionPrompt from './AppVersionPrompt';
import AppVersionTagInput from './AppVersionTagInput';
import { splitAppVersionString } from './appVersionUtils';

import './AppVersionInput.css';

interface AppVersionInputProps extends ControlledInputPropsBase<string> {
  disabled?: boolean;
}

interface AppVersionInputState {
  popoverVisibility: boolean;
}

export class AppVersionInput extends React.Component<
  AppVersionInputProps,
  AppVersionInputState
> {
  state: AppVersionInputState = {
    popoverVisibility: false,
  };

  hidePopover = () => {
    this.setState({
      popoverVisibility: false,
    });
  };

  handlePopoverVisibleChange = (visibility) => {
    const { disabled } = this.props;

    if (!disabled) this.setState({ popoverVisibility: visibility });
  };

  handleRemoveAppVersion = (index) => {
    const { value, onChange } = this.props;
    const appVersions = splitAppVersionString(value);
    appVersions.splice(index, 1);
    onChange(appVersions.join(','));
  };

  handleAppVersionChange = (index, val) => {
    const { value, onChange } = this.props;
    const appVersions = splitAppVersionString(value);
    appVersions[index] = val;
    onChange(appVersions.join(','));
  };

  handleEnterAppVersion = (newAppVersion) => {
    const { value, onChange } = this.props;
    const appVersions = splitAppVersionString(value);
    this.hidePopover();
    if (!value.includes(newAppVersion)) {
      onChange([...appVersions, newAppVersion].join(','));
    }
  };

  render() {
    const { value, disabled } = this.props;
    const appVersions = splitAppVersionString(value);

    const { popoverVisibility } = this.state;
    return (
      <div className="app-version-input__container">
        {appVersions.map((appVersion, index) => (
          <span key={appVersion}>
            <AppVersionTagInput
              value={appVersion}
              disabled={disabled}
              onChange={(val) => this.handleAppVersionChange(index, val)}
              onClose={() => this.handleRemoveAppVersion(index)}
            />
          </span>
        ))}
        <Popover
          placement="bottomLeft"
          content={
            <AppVersionPrompt
              onSubmit={this.handleEnterAppVersion}
              onCancel={this.hidePopover}
            />
          }
          destroyTooltipOnHide={true}
          trigger="click"
          open={popoverVisibility}
          onOpenChange={this.handlePopoverVisibleChange}
        >
          <Tooltip title="Add a new version" placement="top">
            <Button
              type="secondary"
              disabled={disabled}
              size="small"
              shape="circle"
              icon={<AddUniversal />}
            />
          </Tooltip>
        </Popover>
      </div>
    );
  }
}

export default AppVersionInput;
